import React from 'react';
import './SkeletonLoader.css';

const SkeletonLoader = ({ type = 'default', lines = 3, className = '' }) => {
  const renderSkeleton = () => {
    switch (type) {
      case 'hero':
        return (
          <div className={`skeleton-hero ${className}`}>
            <div className="skeleton-title"></div>
            <div className="skeleton-text"></div>
            <div className="skeleton-text short"></div>
            <div className="skeleton-button"></div>
          </div>
        );

      case 'card':
        return (
          <div className={`skeleton-card ${className}`}>
            <div className="skeleton-image"></div>
            <div className="skeleton-content">
              <div className="skeleton-title"></div>
              <div className="skeleton-text"></div>
              <div className="skeleton-text short"></div>
            </div>
          </div>
        );

      case 'section':
        return (
          <div className={`skeleton-section ${className}`}>
            <div className="skeleton-header">
              <div className="skeleton-title large"></div>
              <div className="skeleton-text"></div>
            </div>
            <div className="skeleton-grid">
              {[...Array(3)].map((_, index) => (
                <div key={index} className="skeleton-item">
                  <div className="skeleton-icon"></div>
                  <div className="skeleton-text"></div>
                </div>
              ))}
            </div>
          </div>
        );

      case 'app':
        return (
          <div className={`skeleton-app ${className}`}>
            <div className="skeleton-logo"></div>
            <div className="skeleton-title">Trainer Max</div>
            <div className="skeleton-spinner"></div>
          </div>
        );

      default:
        return (
          <div className={`skeleton-default ${className}`}>
            {[...Array(lines)].map((_, index) => (
              <div key={index} className="skeleton-line"></div>
            ))}
          </div>
        );
    }
  };

  return renderSkeleton();
};

export default SkeletonLoader; 